import { useHerdControlAnalytics } from "features/shared/hooks/useHerdControlAnalytics";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "redux/actions";
import { deveExibirConciliacao } from "../../shared/utils";
import * as BalancoArrobaOperations from "../redux/balancoArrobaOperations";
import ArrobaBalancePage from "./arrobaBalancePage";

export const ArrobaBalanceContainer = ({
  balancosFazenda,
  dataInicioConciliacao,
  obterDatas,
  obterDadosBalanco,
  permiteBalanco,
  datas,
  desativaModalFaltaData,
  exibirModalFaltaDataInicial,
  exibirModalPesagensInsuficientes,
}) => {
  const { trackEvent } = useHerdControlAnalytics({
    tabName: "Balanço de Arroba",
  });

  useEffect(() => {
    trackEvent();

    // We want to run this only once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ArrobaBalancePage
      conciliationStartDate={dataInicioConciliacao}
      dates={datas}
      farmBalances={balancosFazenda}
      getBalanceData={obterDadosBalanco}
      getDates={obterDatas}
      onCloseMissingConciliationDateModal={desativaModalFaltaData}
      showArrobaBalance={permiteBalanco}
      showInsufficientWeighingModal={exibirModalPesagensInsuficientes}
      showMissingConciliationDateModal={exibirModalFaltaDataInicial}
    />
  );
};

const mapStateToProps = (state) => {
  const { fazenda, balanco } = state;
  const permiteBalanco = deveExibirConciliacao(state);
  let dataInicioConciliacao;
  fazenda.Fazendas.forEach((value) => {
    if (value.IdFazenda === fazenda.FazendaSelecionada)
      dataInicioConciliacao = value.DataInicioConciliacao;
  });

  return {
    balancosFazenda: balanco.Balancos,
    arrayBalancos: balanco.Balancos.Categorias,
    dataInicioConciliacao: dataInicioConciliacao,
    permiteBalanco,
    datas: balanco.data,
    exibirModalPesagensInsuficientes: balanco.exibirModalPesagensInsuficientes,
    exibirModalFaltaDataInicial: balanco.exibirModalFaltaDataInicial,
  };
};

const mapDispatchToProps = {
  loading: actions.exibirCarregandoSalvando,
  obterDatas: BalancoArrobaOperations.obterDatas,
  obterDadosBalanco: BalancoArrobaOperations.obterDadosBalanco,
  desativaModalFaltaData: BalancoArrobaOperations.desativaModalFaltaData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArrobaBalanceContainer);
